"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventProbabilityOutcomeNameV3 = void 0;
exports.getOutcomeName = getOutcomeName;
const customizeOutcomeName_1 = require("./customizeOutcomeName");
const getOutcomeNameWithoutCustomization_1 = require("./getOutcomeNameWithoutCustomization");
const getProbabilityOutcomeName = (outcomeType, competitors, isShortNamed) => {
    const { homeCompetitors, awayCompetitors } = competitors;
    const homeCompetitorNames = homeCompetitors.map((c) => c.name).join(', ');
    const awayCompetitorNames = awayCompetitors.map((c) => c.name).join(', ');
    const name = isShortNamed ? outcomeType.shortName : outcomeType.name;
    return name
        .replaceAll('{$competitor1}', homeCompetitorNames)
        .replaceAll('{$competitor2}', awayCompetitorNames);
};
function getOutcomeName(args) {
    return (0, exports.getEventProbabilityOutcomeNameV3)({
        market: args.vMarketInfo,
        eventProbability: args.eventProbability,
        players: args.players,
        templateId: args.templateId,
        outcomeType: args.outcomeType,
        eventCompetitors: args.eventCompetitors,
        isShortNamed: args.isShortNamed,
    });
}
const getEventProbabilityOutcomeNameV3 = ({ eventProbability, market, players, templateId, outcomeType, eventCompetitors, isShortNamed, }) => {
    const outcomeTypeName = getProbabilityOutcomeName(outcomeType, eventCompetitors, isShortNamed);
    if (market.shouldCustomizeOutcomeName) {
        const { customName, isCustomized } = (0, customizeOutcomeName_1.customizeOutcomeName)({
            eventProbability,
            market,
            eventCompetitors,
            isShortNamed,
            players,
            outcomeTypeName,
        });
        if (isCustomized)
            return customName;
    }
    let hasCustomOutcomeNameWithoutTemplate = false;
    if (market.outcomeCustomizations) {
        hasCustomOutcomeNameWithoutTemplate = market.outcomeCustomizations.some((el) => el.name || el.shortName);
    }
    if (hasCustomOutcomeNameWithoutTemplate) {
        const { customName, isCustomized } = (0, customizeOutcomeName_1.customizeOutcomeNameWithoutTemplate)({
            eventProbability,
            market,
            isShortNamed,
        });
        if (isCustomized)
            return customName;
    }
    return (0, getOutcomeNameWithoutCustomization_1.getOutcomeNameWithoutCustomization)({
        templateId,
        players,
        outcomeTypeName,
        eventProbability,
    });
};
exports.getEventProbabilityOutcomeNameV3 = getEventProbabilityOutcomeNameV3;
//# sourceMappingURL=getEventProbabilityOutcomeNameV3.js.map